var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighAndCriticalRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    fill: "#FFD2C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    stroke: "#FFD2C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8023 12.475C10.935 12.3472 11.0013 12.1889 11.0013 12C11.0013 11.8111 10.935 11.6528 10.8023 11.525C10.6696 11.3972 10.5051 11.3333 10.3089 11.3333C10.1128 11.3333 9.94831 11.3972 9.8156 11.525C9.68288 11.6528 9.61653 11.8111 9.61653 12C9.61653 12.1889 9.68288 12.3472 9.8156 12.475C9.94831 12.6028 10.1128 12.6667 10.3089 12.6667C10.5051 12.6667 10.6696 12.6028 10.8023 12.475ZM9.61653 10H11.0013V6.66668H9.61653V10ZM10.3089 16.6667C8.70485 16.2778 7.38062 15.3917 6.33623 14.0083C5.29185 12.625 4.76965 11.0889 4.76965 9.40001V5.33334L10.3089 3.33334L15.8482 5.33334V9.40001C15.8482 11.0889 15.326 12.625 14.2816 14.0083C13.2373 15.3917 11.913 16.2778 10.3089 16.6667ZM10.3089 15.2667C11.5091 14.9 12.5016 14.1667 13.2863 13.0667C14.071 11.9667 14.4634 10.7445 14.4634 9.40001V6.25001L10.3089 4.75001L6.15447 6.25001V9.40001C6.15447 10.7445 6.54684 11.9667 7.33157 13.0667C8.1163 14.1667 9.10876 14.9 10.3089 15.2667Z",
    fill: "#DE350B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighAndCriticalRisk);
export default __webpack_public_path__ + "static/media/HighAndCriticalRisk.b65056c99527ebdfb8a174c4f8f4c606.svg";
export { ForwardRef as ReactComponent };